export function clamp(x: number, floor: number, ceiling: number): number {
  if (ceiling < floor) {
    throw new Error(`Invalid range from ${floor} to ${ceiling}.`);
  }
  return Math.min(ceiling, Math.max(x, floor));
}
